import { AxiosRequestConfig } from 'axios'
import { Repository } from 'ecp/repositories/Repository'
import api from 'services/api'

export interface IApiPartnerNecessaryDocuments {
  comprovanteEndereco: boolean
  holerite: boolean
  ultimoComprovantePagamentoBeneficio: boolean
  tresUltimosExtratos: boolean
  extratoBancario: boolean
  cnpjContratoSocial: boolean
}

export interface IApiPartnerNecessaryDocumentsResponse {
  simulationId: string
  documents: IApiPartnerNecessaryDocuments
}

class ApiPartnerDocumentsRepository extends Repository<IApiPartnerNecessaryDocumentsResponse> {
  async getNecessaryDocuments (simulationId: string, config?: AxiosRequestConfig) {
    return Repository.handle<IApiPartnerNecessaryDocumentsResponse>(() =>
      this.api.get(`${this.path}/${simulationId}/necessary-documents`, config)
    )
  }
}

export default new ApiPartnerDocumentsRepository({ api, path: '/api-partner-documents' })
